import { Component } from '@angular/core';
import { TK } from '../../../core/i18n';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-orientation-warning',
  imports: [TranslatePipe],
  template: `
    <div class="orientation-overlay" aria-hidden="true">
      <div class="orientation-message" [innerHTML]="TK.orientationMessage | translate"></div>
    </div>
  `,
  styles: `
    .orientation-overlay {
      display: none;
    }

    @media (max-width: 768px) and (orientation: portrait) {
      .orientation-overlay {
        position: fixed;
        inset: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 1rem;
        background: rgba(0, 0, 0, 0.7);
        backdrop-filter: blur(0.125rem);
        z-index: 1000;
      }

      .orientation-message {
        max-width: 35rem;
        color: var(--color-white);
        text-align: center;
        font-size: 1.125rem;
        font-weight: 700;
        user-select: none;
      }
    }
  `,
})
export class OrientationWarning {
  protected readonly TK = TK;
}
